<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 499.75 166.48">
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_1-2" data-name="Layer 1">
        <path
          class="cls-1"
          d="M14.39,156.81c3.22-50.63,8-73.47,10.75-118.5h0C43,80.87,53.77,98.26,75.53,143.39a4.27,4.27,0,0,0,8.13-.85c10.16-48.62,20.71-71.91,32.44-118.3h0c18.64,47.43,34.58,83.66,50.84,130.49,1.79,5.15,9.68,2,7.89-3.1C155.68,96.55,134,53.31,119.29,8.65c-1.36-4.17-7.26-3.05-8.13.85C100.87,55.82,88.33,83.15,78,129.47c5.08-.18-2.71.28,0,0C54.85,86.41,47.41,63.57,25.92,20.9c-1.67-3.31-7.84-3.76-8.13.85C15,66.77,10.16,110.5,6,155.42,5.52,160.83,13.88,162.25,14.39,156.81Z"
        />
        <path
          class="cls-1"
          d="M480.14,35.45c1.67,39.46,6.2,80.72,6,120.22,0,4.76,7.54,4.77,7.56,0,.17-39.5-4.37-80.76-6-120.22C487.5,30.7,479.94,30.68,480.14,35.45Z"
        />
        <path
          class="cls-1"
          d="M308.39,153.29c2.47-56.54,5.2-74.37,7.24-119h0c35,46.9,61,81.25,99.83,125,2.3,2.57,6.7.8,6.83-2.56,1.69-45,11.14-89.73,12.83-134.75.19-5.07-7.85-5.35-7.88-.27-.28,49.12-10.66,80-12.35,125h0C376,103,350.07,67.38,315.11,20.49c-2.13-2.87-6.68-.59-6.82,2.55-2,44.62-5.73,85.34-7.77,130C300.28,158.08,308.16,158.36,308.39,153.29Z"
        />
        <path
          class="cls-1"
          d="M226.78,36a836,836,0,0,1-1.85,115.87c-.41,4.75,7.21,4.72,7.62,0A836,836,0,0,0,234.4,36C234.15,31.27,226.52,31.24,226.78,36Z"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'TheMiniTextIcon',
};
</script>

<style scoped>
.cls-1 {
  fill: #363636;
  stroke: #363636;
  stroke-miterlimit: 10;
  stroke-width: 12px;
}
</style>
